import React, {useEffect} from 'react';
// noinspection ES6CheckImport
import {connectPagination} from 'react-instantsearch-dom';
import {makeStyles} from '@material-ui/core/styles';
import {useDispatch, useSelector} from 'react-redux';
import {setSearchPage} from '../../redux/actions/search';
import {SELECTOR_SEARCH_PAGE} from '../../redux/selectors/search';
import {useParams} from 'react-router-dom/cjs/react-router-dom.min';

// pagination
const useStylesPagination = makeStyles({
  root: {
    display: 'flex',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    flexDirection: 'row',
  },
  item: {
    display: 'flex',
    padding: 5,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #f2f2f2',
    cursor: 'pointer',
    '&:not(:last-child)': {
      marginRight: 5,
    },
    '&:hover': {
      marginRight: 5,
      backgroundColor: '#f2f2f2',
    },
  },
});

function Pagination({nbPages, refine, reset}) {
  const cr = useSelector(SELECTOR_SEARCH_PAGE);
  const styles = useStylesPagination();
  const dispatch = useDispatch();
  const params = useParams();

  function onClick(e, value) {
    e.preventDefault();
    dispatch(setSearchPage(value));
    window.scrollTo(0, 10);
  }

  useEffect(() => {
    dispatch(setSearchPage(1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.c_name]);

  if (!nbPages) return <div></div>;

  return (
    <ul className={styles.root}>
      <li className={styles.item} onClick={(e) => onClick(e, 1)}>
        {'<<'}
      </li>
      <li className={styles.item} onClick={(e) => onClick(e, Math.max(1, cr - 1))}>
        {'<'}
      </li>
      {new Array(nbPages).fill(null).map((_, i) => {
        const page = i + 1;
        if (page < cr - 5 || page > cr + 5) return <div key={i} />;
        const style = {
          fontWeight: cr === page ? 'bold' : 'light',
          color: cr === page ? '#1374EE' : 'rgb(95 95 95)',
        };
        return (
          <li key={i} className={styles.item} style={style} onClick={(e) => onClick(e, page)}>
            {page}
          </li>
        );
      })}
      <li className={styles.item} onClick={(e) => onClick(e, Math.min(nbPages, cr + 1))}>
        {'>'}
      </li>
      <li className={styles.item} onClick={(e) => onClick(e, nbPages)}>
        {'>>'}
      </li>
    </ul>
  );
}

export default connectPagination(Pagination);
